import { useTranslation } from 'react-i18next';

import type { IllustrationName } from '~/components';

import { Card, Illustration, Text, Title } from '~/components';

import {
  disclaimerStyle,
  stepCardStyle,
  stepContentStyle,
  stepIllustrationStyle,
  stepIllustrationWrapperStyle,
  stepLabelStyle,
  stepNumberStyle,
  stepsStyle,
  wrapperStyle,
} from './HowItWorks.css';

export const HowItWorks = () => {
  const { t } = useTranslation(['invitations']);

  const steps: { illustration: IllustrationName; label: string; strokeWidth: number }[] = [
    { illustration: 'HandsTyping', label: t('invitations:howItWorks.steps.register'), strokeWidth: 0.8 },
    { illustration: 'PersonComputer2', label: t('invitations:howItWorks.steps.invoice'), strokeWidth: 0.8 },
    { illustration: 'Discount', label: t('invitations:howItWorks.steps.earn'), strokeWidth: 0.8 },
  ];

  return (
    <div className={wrapperStyle}>
      <Title as="h3">{t('invitations:howItWorks.title')}</Title>

      <div className={stepsStyle}>
        {steps.map((step, index) => (
          <Card.Root className={stepCardStyle} key={step.label} size="small" variant="secondary-light">
            <div className={stepIllustrationWrapperStyle}>
              <Illustration className={stepIllustrationStyle} name={step.illustration} strokeWidth={step.strokeWidth} />
            </div>

            <div className={stepContentStyle}>
              <span className={stepNumberStyle}>{index + 1}</span>

              <span className={stepLabelStyle}>{step.label}</span>
            </div>
          </Card.Root>
        ))}
      </div>

      <Text className={disclaimerStyle}>{t('invitations:howItWorks.disclaimer')}</Text>
    </div>
  );
};
